import { Reveal } from "@/components/Reveal";

export const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      <img
        src="/images/hero.jpg"
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/55" />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pt-32 pb-24">
        <div className="max-w-2xl">
        <Reveal>
          <p className="text-xs tracking-[0.35em] uppercase text-[#E0A8C5] mb-10">
            Private End-of-Life Experiences
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <h1 className="font-serif-display font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.08] text-[#FCF5EB]">
            A living goodbye,
            <br />
            <span className="italic text-[#D9A441]">designed on your terms.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-10 max-w-xl text-base md:text-lg font-light leading-relaxed text-[#FCF5EB]/85">
            A farewell you can be there for. We design and execute
            celebrations as extraordinary as the life you've lived — anywhere
            in the world, with the utmost discretion.
          </p>
        </Reveal>
        <Reveal delay={0.45}>
          <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center gap-6">
            <a
              href="#enquiry"
              className="border border-[#FCF5EB] text-[#FCF5EB] px-10 py-4 text-xs tracking-[0.25em] uppercase hover:bg-[#7D1B56] hover:border-[#7D1B56] transition-colors duration-500"
              data-testid="hero-enquiry-cta"
            >
              Begin a Private Conversation
            </a>
            <a
              href="#experiences"
              className="text-xs tracking-[0.25em] uppercase text-[#FCF5EB]/70 hover:text-[#FCF5EB] transition-colors duration-300 border-b border-transparent hover:border-[#D9A441] pb-1"
              data-testid="hero-explore-cta"
            >
              Discover the Experiences
            </a>
          </div>
        </Reveal>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 w-px h-16 bg-[#FCF5EB]/40" aria-hidden="true" />
    </section>
  );
};
